<!-- 高拍仪/摄像头拍照上传 -->
<template>
    <el-dialog v-dialogDrag title="拍照上传" :visible.sync="dialogFormVisible" width="70%"
        :close-on-click-modal="false" :close-on-press-escape="false" :before-close="handleClose" @opened="handleOpened">
        <div class="camera_outer">
            <video ref="videoCamera" class="video-container" autoplay playsinline></video>
            <canvas ref="canvasCamera" style="display:none;"></canvas>
            <div v-if="!stream" class="camera_tip">摄像头未打开</div>
        </div>
        <div class="camera_btn">
            <el-select v-model="deviceId" size="mini" style="width: 240px;" placeholder="请选择设备"
                @change="openCamera">
                <el-option v-for="item in deviceList" :key="item.deviceId" :label="item.label"
                    :value="item.deviceId"></el-option>
            </el-select>
            <el-button icon="el-icon-video-camera" type="success" size="mini" @click="openCamera">打开摄像头</el-button>
            <el-button icon="el-icon-close" type="info" size="mini" @click="closeCamera">关闭摄像头</el-button>
            <el-button icon="el-icon-camera" type="primary" size="mini" @click="capture">拍照</el-button>
            <el-button icon="el-icon-delete" type="danger" size="mini" :disabled="fileList.length === 0"
                @click="clearPhoto">清空</el-button>
            <el-button icon="el-icon-upload2" type="warning" size="mini" :loading="uploadLoading"
                @click="sendPhoto">上传</el-button>
            <span class="camera_size" v-if="videoWidth > 0">分辨率：{{ videoWidth }} × {{ videoHeight }}</span>
        </div>
        <div class="preview_box" v-if="fileList.length > 0">
            <div class="preview_item" v-for="(item, index) in fileList" :key="item.uid">
                <img :src="item.url" class="preview_img">
                <i class="el-icon-close preview_del" @click="deletePhoto(index)"></i>
            </div>
        </div>
    </el-dialog>
</template>

<script>
export default {
    props: ['row', 'onlyPhoto'],
    data() {
        return {
            dialogFormVisible: false,
            deviceList: [],      // 摄像头/高拍仪设备列表
            deviceId: '',        // 当前选中的设备
            stream: null,        // 当前视频流，关闭时用来释放设备
            fileList: [],        // 已拍待上传的照片
            videoWidth: 0,       // 设备真实出图宽
            videoHeight: 0,      // 设备真实出图高
            uploadLoading: false,// 上传中
        }
    },
    beforeDestroy() {
        // 组件销毁一定要释放设备，否则摄像头/高拍仪指示灯会一直亮着
        this.closeCamera();
    },
    methods: {
        // 兼容父页面原来的写法，父页面 $nextTick 里调的就是这个方法
        getCompetence() {
            this.getDeviceList();
            this.$nextTick(() => {
                this.openCamera();
            });
        },
        // 弹窗完全打开后再初始化，el-dialog 的 body 是懒渲染的，提前取不到 video
        handleOpened() {
            this.getDeviceList();
        },
        // 获取设备列表，权限通过后 label 才会带上设备名
        getDeviceList() {
            if (!navigator.mediaDevices || !navigator.mediaDevices.enumerateDevices) {
                return;
            }
            //  列出所有媒体设备（摄像头、麦克风等）
            navigator.mediaDevices.enumerateDevices().then(devices => {
                // 筛选出所有视频设备
                const list = devices.filter(item => item.kind === 'videoinput');
                this.deviceList = list.map((item, index) => {
                    return {
                        deviceId: item.deviceId,
                        label: item.label || ('摄像头' + (index + 1))
                    }
                });
                if (!this.deviceId && this.deviceList.length > 0) {
                    this.deviceId = this.deviceList[0].deviceId;
                }
            }).catch(err => {
                console.log(err);
            })
        },
        // 打开摄像头，高拍仪在系统里就是一个摄像头设备
        openCamera() {
            this.closeCamera();
            if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
                this.$message({
                    type: 'error',
                    message: '当前浏览器不支持摄像头，请用 https 或 localhost 访问！'
                });
                return;
            }
            const constraints = {
                audio: false,
                video: this.deviceId
                    ? { deviceId: { exact: this.deviceId }, width: { ideal: 2560 }, height: { ideal: 1944 } }
                    : { width: { ideal: 2560 }, height: { ideal: 1944 } }
            }
            navigator.mediaDevices.getUserMedia(constraints).then(stream => {
                this.stream = stream;
                // 清晰度优化：查询设备预览流支持的最大分辨率并锁定，避免浏览器静默降级
                const track = stream.getVideoTracks()[0];
                if (track && track.getCapabilities) {
                    const caps = track.getCapabilities();
                    if (caps.width && caps.width.max && caps.height && caps.height.max) {
                        track.applyConstraints({
                            width: { exact: caps.width.max },
                            height: { exact: caps.height.max }
                        }).catch(() => { /* 个别驱动不接受 exact，忽略即可 */ });
                    }
                }
                const video = this.$refs.videoCamera;
                video.srcObject = stream;
                // applyConstraints 后分辨率可能变化，这里同步刷新界面上显示的分辨率
                video.onresize = () => {
                    this.videoWidth = video.videoWidth;
                    this.videoHeight = video.videoHeight;
                }
                video.onloadedmetadata = () => {
                    video.play(); // 开始播放
                    this.videoWidth = video.videoWidth;
                    this.videoHeight = video.videoHeight;
                    // 授权之后 label 才带设备名，这里刷新一次列表
                    this.getDeviceList();
                }
            }).catch(err => {
                console.log(err);
                this.$message({
                    type: 'error',
                    message: '打开摄像头失败：' + (err && err.message ? err.message : '请检查设备是否被其他程序占用')
                });
            })
        },
        // 关闭摄像头并释放设备
        closeCamera() {
            if (this.stream) {
                this.stream.getTracks().forEach(track => {
                    track.stop();
                });
                this.stream = null;
            }
            const video = this.$refs.videoCamera;
            if (video) {
                video.srcObject = null;
            }
            this.videoWidth = 0;
            this.videoHeight = 0;
        },
        // 拍照：优先走设备静态拍照通道（能拿全分辨率，更清晰），不支持时回退到截视频帧
        async capture() {
            const video = this.$refs.videoCamera;
            const canvas = this.$refs.canvasCamera;
            if (!this.stream || !video.videoWidth) {
                this.$message({
                    type: 'warning',
                    message: '请先打开摄像头！'
                });
                return;
            }
            const track = this.stream.getVideoTracks()[0];
            let stillOk = false;
            if (track && typeof ImageCapture !== 'undefined') {
                try {
                    // 静态拍照走驱动 still pin，分辨率不受预览流限制
                    const blob = await new ImageCapture(track).takePhoto();
                    const bitmap = await createImageBitmap(blob);
                    canvas.width = bitmap.width;
                    canvas.height = bitmap.height;
                    canvas.getContext('2d').drawImage(bitmap, 0, 0);
                    if (bitmap.close) {
                        bitmap.close();
                    }
                    stillOk = true;
                } catch (e) {
                    stillOk = false;
                }
            }
            if (!stillOk) {
                // 按设备真实分辨率出图，避免高拍仪的大图被压缩
                canvas.width = video.videoWidth;
                canvas.height = video.videoHeight;
                canvas.getContext('2d').drawImage(video, 0, 0, canvas.width, canvas.height);
            }
            // 0.95 保证文字边缘清晰，质量太低单据字会糊
            const image = canvas.toDataURL('image/jpeg', 0.95);
            const name = (this.row && this.row.deliveryNo ? this.row.deliveryNo : 'photo') + '_' + (crypto.randomUUID().replace(/-/g, '')) + '.jpeg';
            this.fileList.push({
                uid: new Date().getTime() + '' + this.fileList.length,
                name: name,
                url: image,
                raw: this.dataURLtoFile(image, name)
            });
        },
        // base64 转文件
        dataURLtoFile(dataurl, filename) {
            var arr = dataurl.split(',');
            var mime = arr[0].match(/:(.*?);/)[1];
            var bstr = atob(arr[1]);
            var n = bstr.length;
            var u8arr = new Uint8Array(n);
            while (n--) {
                u8arr[n] = bstr.charCodeAt(n);
            }
            return new File([u8arr], filename, { type: mime });
        },
        // 删除单张
        deletePhoto(index) {
            this.fileList.splice(index, 1);
        },
        // 清空全部
        clearPhoto() {
            this.fileList = [];
        },
        // 上传：多张照片用同一个 image 字段一起传，和老接口保持一致
        sendPhoto() {
            if (this.fileList.length === 0) {
                this.$message({
                    type: 'warning',
                    message: '请先拍照！'
                });
                return;
            }
            // 把拍到的图片交给父组件，父组件要用就用
            this.$emit('uploadSuccess', this.fileList);
            // 只拍照不上传，图片由父组件去调识别接口
            if (this.onlyPhoto) {
                this.handleClose();
                return;
            }
            // const formData = new FormData();
            // this.fileList.forEach(item => {
            //     formData.append('image', item.raw);
            // });
            // this.uploadLoading = true;
            // this.$api.taskReceiveImg(formData).then(res => {
            //     this.uploadLoading = false;
            //     // request.js 把 code/message/data 剥了一层，这里拿到的就是 data
            //     this.$message({
            //         type: 'success',
            //         message: typeof res === 'string' && res ? res : '上传成功'
            //     });
            //     this.clearPhoto();
            //     this.handleClose();
            // }).catch(() => {
            //     this.uploadLoading = false;
            // })
        },
        // 关闭弹窗：先释放设备再关
        handleClose(done) {
            this.closeCamera();
            this.clearPhoto();
            this.dialogFormVisible = false;
        }
    },
}
</script>

<style lang="css" scoped>
.camera_outer {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 400px;
    background: #000000;
    overflow: hidden;
}

.camera_outer .video-container {
    width: 100%;
    max-height: 620px;
    object-fit: contain;
}

.camera_tip {
    position: absolute;
    color: #cccccc;
    font-size: 14px;
}

.camera_btn {
    margin-top: 10px;
    text-align: center;
}

.camera_btn .camera_size {
    margin-left: 10px;
    color: #909399;
    font-size: 12px;
}

.preview_box {
    display: flex;
    flex-wrap: wrap;
    margin-top: 10px;
    padding: 10px;
    background-color: #f5f7fa;
    border-radius: 4px;
}

.preview_item {
    position: relative;
    margin: 0 10px 10px 0;
}

.preview_img {
    width: 120px;
    height: 90px;
    object-fit: cover;
    border: 1px solid #dcdfe6;
    border-radius: 4px;
}

.preview_del {
    position: absolute;
    top: -6px;
    right: -6px;
    width: 18px;
    height: 18px;
    line-height: 18px;
    text-align: center;
    color: #ffffff;
    background-color: #f56c6c;
    border-radius: 50%;
    cursor: pointer;
    font-size: 12px;
}
</style>